import { createLoggers } from './logger';
import { serializeErrorForLog } from './serialize-error-for-log';

type NextRequestErrorContext = {
  routerKind: string;
  routePath?: string;
  routeType?: string;
};

type NextRequestErrorRequest = {
  path: string;
  method: string;
};

export function createNextOnRequestErrorLogger(params: { tag: string }) {
  const { error: logError } = createLoggers({ tag: params.tag });

  return async function onRequestError(
    err: Error,
    request: NextRequestErrorRequest,
    context: NextRequestErrorContext,
  ) {
    if (process.env.NEXT_RUNTIME !== 'nodejs') {
      return;
    }

    logError('Next.js request error', {
      error: serializeErrorForLog(err),
      request: {
        path: request.path,
        method: request.method,
      },
      context: {
        routerKind: context.routerKind,
        ...(context.routePath ? { routePath: context.routePath } : {}),
        ...(context.routeType ? { routeType: context.routeType } : {}),
      },
    });
  };
}
